module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//22.jpg?2422aaa1a812576f625bec3a40aab658";